import { render } from "./current-hands.vue?vue&type=template&id=be2cfc20&scoped=true"
import script from "./current-hands.vue?vue&type=script&lang=js"
export * from "./current-hands.vue?vue&type=script&lang=js"

import "./current-hands.vue?vue&type=style&index=0&id=be2cfc20&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2cfc20"]])

export default __exports__